module.exports = __webpack_public_path__ + "img/logo_amikom.953c041f.png";